var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d3fdd85ea6f5b336ef62c882a847fc7db61b5e70"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["landing-v2@staderlabs"]={id:"d3fdd85ea6f5b336ef62c882a847fc7db61b5e70"};
      